import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default {
  namespaced: true,

  state: () => {
    return {};
  },

  actions: {
    async sendFeedback({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/email/bugreport',
          data: parameters,
          headers: {'Content-Type': 'multipart/form-data'},
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }
      return response.data;
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        'api/apiRequest',
        {...parameters, baseUrl: process.env.VUE_APP_FEEDBACK_FUNCTION_URL},
        { root: true },
      );
    },
  },
}
